// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__171qO","messages":"Chat_messages__RVYbq","dateDivider":"Chat_dateDivider__1xLgm"};